import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import MyGoogleMap from './MyGoogleMap';

const MapContainer = ({ center, height, icon, marker, options, zoom }) => {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <MyGoogleMap
      center={center}
      containerElement={<div style={{ height }} />}
      googleMapURL={`https://maps.google.com/maps/api/js?key=${process.env.GOOGLE_PLACE_ID}&libraries=geometry,drawing,places&language=${language}&region=JP`}
      icon={icon}
      loadingElement={<div style={{ height: `100%` }} />}
      mapElement={<div style={{ height: '100%' }} />}
      marker={marker}
      options={options}
      zoom={zoom}
    />
  );
};

MapContainer.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  height: PropTypes.string.isRequired,
  icon: PropTypes.shape({
    scaledSize: PropTypes.shape({ height: PropTypes.number, width: PropTypes.number }),
    url: PropTypes.string,
  }),
  marker: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }),
  options: PropTypes.shape({}),
  zoom: PropTypes.number,
};

MapContainer.defaultProps = {
  icon: undefined,
  marker: null,
  options: {},
  zoom: 12,
};

export default MapContainer;
